import DriveRegistrationForm from 'src/components/nonMasaiDriveRegistrationForm/DriveRegistrationForm';

const NonMasaiDrivePlacementPage = () => {
	return <DriveRegistrationForm />;
};

export default NonMasaiDrivePlacementPage;
